/*
* Copyright (C) Regione Lombardia
*/
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '@shared/shared.module';
import { ToolkitGestioneProgettoModalLeggiProgettoComponent } from './modal-leggi-progetto/modal-leggi-progetto.component';
import { ToolkitGestioneProgettoModalUploadDocumentoComponent } from './modal-upload-documento/modal-upload-documento.component';
import { ToolkitGestioneProgettoTabAnagraficaProgettoComponent } from './tab-anagrafica-progetto/tab-anagrafica-progetto.component';
import { ToolkitGestioneProgettoTabDocumentiComponent } from './tab-documenti/tab-documenti.component';
import { ToolkitGestioneProgettoTabLeggiProgettoComponent } from './tab-leggi-progetto/tab-leggi-progetto.component';
import { ToolkitGestioneProgettoTabOpereAssociateComponent } from './tab-opere-associate/tab-opere-associate.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        SharedModule,
        NgbModule
    ],
    declarations: [
        ToolkitGestioneProgettoModalLeggiProgettoComponent,
        ToolkitGestioneProgettoModalUploadDocumentoComponent,
        ToolkitGestioneProgettoTabAnagraficaProgettoComponent,
        ToolkitGestioneProgettoTabDocumentiComponent,
        ToolkitGestioneProgettoTabLeggiProgettoComponent,
        ToolkitGestioneProgettoTabOpereAssociateComponent
    ],
    exports: [
        ToolkitGestioneProgettoModalLeggiProgettoComponent,
        ToolkitGestioneProgettoModalUploadDocumentoComponent,
        ToolkitGestioneProgettoTabAnagraficaProgettoComponent,
        ToolkitGestioneProgettoTabDocumentiComponent,
        ToolkitGestioneProgettoTabLeggiProgettoComponent,
        ToolkitGestioneProgettoTabOpereAssociateComponent
    ],
    entryComponents: [
        ToolkitGestioneProgettoModalLeggiProgettoComponent,
        ToolkitGestioneProgettoModalUploadDocumentoComponent,
    ],
})
export class PagesGestioneProgettoToolkitModule { }
